/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import CustomInput from "../../../Core/Components/CustomInput";
import ChargerIcon from "../../../Common/Svgs/ChargerIcon";
import ColumnHeader from "./ColumnHeader";
import { client } from "../../../Utils/axiosClient";

const ExistingBatteries = ({
  batteries,
  setBatteries,
  errorIds = [],
  setErrorIds,
}) => {
  const { currentRental } = useSelector((state) => state.rentals);

  const [loading, setLoading] = useState(0);

  // handing the end energy percent
  const handleEndEnergy = (e, id) => {
    // update the error ids
    setErrorIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );

    setBatteries((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, endEnergy: e.target.value } : item,
      ),
    );
  };

  // focus when entering end energy
  const handleFocus = (index, state) => {
    setBatteries((prev) =>
      prev.map((item) =>
        item.id === index ? { ...item, focus: state } : item,
      ),
    );
  };

  // fetch the battery energy capacity from tb (latest entry)
  const getBatteryCapacity = async (batteryId) => {
    try {
      setLoading(+batteryId);
      const response = await client.get(
        `${process.env.REACT_APP_API_URL}/rentals/get-battery-energy-capacity`,
        {
          params: {
            batteryId: +batteryId,
          },
        },
      );

      if (response.status === 200) {
        const { energy } = response.data;

        setBatteries((prev) =>
          prev.map((item) =>
            +item.id === +batteryId ? { ...item, endEnergy: +energy } : item,
          ),
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(0);
    }
  };

  useEffect(() => {
    const initial = currentRental?.batteries?.map((item) => ({
      id: item.id,
      registrationNo: item.registrationNo,
      startEnergy: item.startEnergy,
      endEnergy: item.startEnergy ?? "",
      hubName: currentRental?.hubName,
      focus: false,
    }));

    setBatteries(initial || []);
  }, [currentRental]);

  return (
    <div className="mt-6">
      <p className="px-4 font-poppins font-medium text-xs">
        Enter energy levels of the batteries
      </p>

      <p className="mt-1 mb-6 px-4 font-aileron font-normal text-xs text-dark-gray">
        Record the energy consumed by the batteries for calculating energy total
        revenue generation.
      </p>

      <ColumnHeader type="default" />

      {batteries?.map((item) => {
        const hasError = errorIds.includes(+item.id);

        let border = "";

        if (hasError) {
          border = "error";
        } else if (item.focus) {
          border = "success";
        } else {
          border = "primary";
        }

        return (
          <div
            key={item?.id}
            className="flex items-center py-2 h-12 border-b-[0.5px] border-light-grey"
          >
            <p className="flex-1 px-6 font-aileron text-xs font-semibold text-black">
              {item?.registrationNo}
            </p>

            <p className="flex-1 px-6 font-aileron text-xs font-semibold text-black capitalize">
              {currentRental?.hubName}
            </p>

            <div className="flex-1 px-6 flex items-center">
              <ChargerIcon size={16} className="text-green" />
              <p className="ml-2 font-aileron text-10 font-semibold text-green">
                {item?.startEnergy} kWh
              </p>
            </div>

            <div className="flex-1 px-6 flex items-center">
              <CustomInput
                intent="editCommodity"
                text="generalSettings"
                value={item?.endEnergy}
                focus={item?.focus}
                border={border}
                placeholder={item?.focus ? null : "Energy"}
                onFocus={() => handleFocus(item.id, true)}
                onBlur={() => handleFocus(item.id, false)}
                onChange={(e) => handleEndEnergy(e, item.id)}
              />

              <p className="ml-2 flex-1 font-aileron font-semibold text-xs text-dark-gray capitalize">
                kWh
              </p>

              <div
                role="button"
                className="ml-2 flex items-center gap-x-2 bg-primary hover:bg-primary-50 rounded-md px-3 py-2"
                onClick={() => getBatteryCapacity(item.id)}
              >
                <p className="font-aileron text-xs font-medium text-white whitespace-nowrap">
                  Fetch Data
                </p>

                <Spin
                  spinning={+item.id === loading}
                  indicator={<LoadingOutlined />}
                  className="text-white"
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ExistingBatteries;
